import * as moment from 'moment';

export class date {

    static getNowUtc() : Date {
      //return moment.utc().toDate();
      //moment sucks so for now I'll do it in a simple and stupid way
      let nowLocal = new Date();
      return new Date(nowLocal.getUTCFullYear(), nowLocal.getUTCMonth(), nowLocal.getUTCDate(), nowLocal.getUTCHours(), nowLocal.getUTCMinutes(), nowLocal.getUTCSeconds());
    }

}
